import { Box, Image } from '@chakra-ui/react';
import React from 'react';
import LectureCard from './LectureCard';
import { useUserActivity } from '../../../../hooks/V2/useUserActivity';

const LectureBlockItems = ({ blockItems }: any) => {
	const { data: activityData, isLoading } = useUserActivity();

	return (
		<Box display={'flex'} flexWrap="wrap" gap="16px" pb="100px">
			{blockItems
				? // @ts-ignore
				  blockItems?.map(item => {
						const lecture = item?.lecture;
						const lectureMeta = {
							_id: lecture?._id,
							image: lecture?.meta?.image || 'NA',
							title: lecture?.meta?.title || 'NA',
							tag: lecture?.meta?.tag || 'MASTERCLASS',
							date: lecture?.meta?.date || 'NA',
							time: lecture?.meta?.time || 'NA',
							ctaText: 'WATCH VIDEO',
						};
						return <LectureCard lecture={lectureMeta} lectureProgress={activityData?.find(data => data?.entity === lecture?._id)} />;
				  })
				: null}
		</Box>
	);
};

export default LectureBlockItems;
